import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["method", "bankWrapper", "bank"]

  connect() {
    this.toggleBank()
    this.element.dataset.paymentFormReady = "true"
  }

  toggleBank() {
    const usesBankTransfer = this.methodTarget.value === "bank_transfer"

    this.bankWrapperTarget.hidden = !usesBankTransfer
    this.bankTarget.disabled = !usesBankTransfer
    this.bankTarget.required = usesBankTransfer

    if (!usesBankTransfer) {
      this.bankTarget.value = ""
    }
  }
}
